<script>
import Button from "@/components/atoms/button";
import { pageProductSheetProps, usePageProductSheet } from "./mixin";
import { useProductSheetBreadcrumb } from "@/components/organisms/product-sheet/mixins/product-sheet-breadcrumb.mixin";
import Breadcrumbs from "@/components/molecules/breadcrumbs/mobile";
import { useNavigationPagesStructuredDataProductSheet } from "@/mixins/seo/navigationPagesStructuredDataProductSheet";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import SmartBanner from "@/components/molecules/smartbanner";

import ProductDetails from "@/containers/product-sheet/product-details";
import PushProductsBlock from "@/containers/product-sheet/push-products-block";
import AdditionalDetails from "@/containers/product-sheet/additional-details";
import ProductReviewDetails from "@/containers/product-sheet/product-reviews-details";
import Container from "@/components/atoms/container";
import { useContextStore } from "@/store/context";

export default {
  name: "ProductSheetMobile",
  components: {
    Button,
    Breadcrumbs,
    HtmlParser,
    ProductDetails,
    PushProductsBlock,
    AdditionalDetails,
    ProductReviewDetails,
    Container,
    SmartBanner
  },
  props: {
    ...pageProductSheetProps()
  },
  setup(props) {
    const { isDisplayModeAppli } = useContextStore();
    const { parentLevel, breadcrumbs } = useProductSheetBreadcrumb(props);
    const {
      hasSyndigoContent,
      ProductSheetCodes,
      displayMode,
      productInfo,
      photos,
      pushZoneTitle,
      recettePosition,
      getPushData,
      hasReviews,
      mounted
    } = usePageProductSheet(props);

    const { head } = useNavigationPagesStructuredDataProductSheet(
      productInfo.value,
      props.product,
      props.reviews,
      props.statistics,
      breadcrumbs.value
    );

    useHead(head);

    onMounted(mounted);
    return {
      parentLevel,
      breadcrumbs,
      hasSyndigoContent,
      ProductSheetCodes,
      displayMode,
      productInfo,
      photos,
      pushZoneTitle,
      recettePosition,
      hasReviews,
      getPushData,
      isDisplayModeAppli
    };
  }
};
</script>

<template>
  <ClientOnly v-if="!isDisplayModeAppli">
    <SmartBanner is-drive-app />
  </ClientOnly>
  <div v-if="displayMode">
    <div class="u-bgcolor-white u-pl-sm u-pr-sm">
      <AdditionalDetails
        :product-info="productInfo"
        class="c-product-sheet-page__additional-details Mob_FP_Infos"
      />
      <div
        v-if="hasReviews"
        class="u-bgcolor-white Mob_FP_Avis"
      >
        <ProductReviewDetails
          :shop-id="shopId"
          :reviews="reviews"
          :statistics="statistics"
          :product-id="parseInt(product.id)"
          class="c-product-sheet-page-mobile_reviews-details"
        />
      </div>
    </div>
  </div>
  <div v-else-if="productInfo">
    <div class="u-bgcolor-white">
      <Container>
        <Breadcrumbs :breadcrumbs="breadcrumbs" />
        <div class="c-product-sheet-page-mobile Mob_FP_Details">
          <ProductDetails
            :photos="photos"
            :product="product"
            :breadcrumb="breadcrumb"
            :is-replaced-by-national="isReplacedByNational"
            :is-popin="isPopin"
            :from-prospectus="fromProspectus"
          />
        </div>
        <div class="u-bgcolor-white Mob_FP_Infos">
          <AdditionalDetails
            :product-info="productInfo"
            class="c-product-sheet-page__additional-details"
          />
        </div>
        <template v-if="!isReplacedByNational && productInfo.associations && (productInfo.associations.alternatifs && productInfo.associations.alternatifs.data && productInfo.associations.alternatifs.data.length > 0 || productInfo.associations.similaire && productInfo.associations.similaire.data.length > 0 )">
          <h2 class="c-product-sheet-page-mobile__heading Mob_FP_Suggestions_1">
            {{ pushZoneTitle }}
          </h2>
          <client-only>
            <PushProductsBlock
              :product="product"
              :visible-product="1"
              :recette-index="recettePosition"
              zone="up"
              class="c-product-sheet-page-mobile__push-product Mob_FP_Suggestions_2"
            />
          </client-only>
          <div
            v-if="parentLevel"
            class="c-product-sheet-page-mobile__heading Mob_FP_Suggestions_3"
          >
            <Button
              variant="primary"
              size="sm"
              radius="full"
              :to="parentLevel"
            >
              Voir les produits similaires
            </Button>
          </div>
        </template>
        <HtmlParser
          v-if="getPushData(ProductSheetCodes.FP_ZONE_LIBRE).html_content"
          class="c-cms-container__content u-py-sm"
          :content="getPushData(ProductSheetCodes.FP_ZONE_LIBRE).html_content"
        />
        <client-only>
          <div v-show="hasSyndigoContent">
            <h2 class="u-text-center u-color-primary u-pt-md u-pb-md">
              La marque vous informe
            </h2>
            <div id="syndi_inline"></div>
          </div>
        </client-only>
        <template v-if=" productInfo.associations && productInfo.associations.protection && productInfo.associations.protection.data.length > 0 ">
          <h2 class="c-product-sheet-page-mobile__heading">
            Pensez à vous protéger
          </h2>
          <client-only>
            <PushProductsBlock
              :product="product"
              :visible-product="1"
              zone="down"
              class="c-product-sheet-page-mobile__push-product"
            />
          </client-only>
        </template>

        <div
          v-if="hasReviews"
          id="avis-clients"
          class="u-bgcolor-white Mob_FP_Avis"
        >
          <ProductReviewDetails
            :shop-id="shopId"
            :reviews="reviews"
            :statistics="statistics"
            :product-id="parseInt(product.id)"
            class="c-product-sheet-page-mobile_reviews-details"
          />
        </div>
      </Container>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-sheet-mobile.scss";
@import "@/assets/styles/globals/cms.scss";
</style>
